var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home"},[_c('NavBar',{attrs:{"headtitle":'选择角色',"typeFn":2}}),_c('div',{staticClass:"serverBox"},[_c('div',{staticClass:"serverList"},[_c('ul',[_vm._l((_vm.roleList),function(item){return _c('li',{key:item.role_id,on:{"click":function($event){return _vm.$router.push({
              path: '/sell',
              query: {
                gameName: _vm.gameName,
                gameId: _vm.gameId,
                serverName: _vm.serverName,
                serverid: _vm.serverId,
                id: item.role_id,
              },
            })}}},[_c('img',{attrs:{"src":item.role_avatar,"alt":""}}),_vm._v("\n          "+_vm._s(item.role_name)+"\n        ")])}),(_vm.roleList.length == 0)?_c('div',{staticStyle:{"padding":"20px","font-size":"12px"}},[_vm._v("\n          暂无角色\n        ")]):_vm._e()],2)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }